export const VisibleToListWithUnknown = [{ "Value": "NotSet", "Label": "" },
{ "Value": "All" , "Label": "All"},
{ "Value": "Internal", "Label": "Internal" }];

export const VisibleToList = [{ "Value": "All", "Label": "All" },
{ "Value": "Internal", "Label": "Internal" }];